var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.name)?_c('fa-icon',{staticClass:"marker-helper has-text-info",attrs:{"icon":"info-circle"},on:{"click":function($event){return _vm.$helper.show(_vm.name)}}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }